import * as React from 'react';
import './PageHeader.scss';
const PageHeader = ({ children, sticky }) => (React.createElement("header", { className: `page-header ${sticky ? 'sticky' : ''}` },
    React.createElement("div", { className: "page-header-inner" }, children)));
export default PageHeader;
